import { GovernanceRole, IPersonOfBusinessEntity } from '@commenda/types';

export enum KeyPersonRolesEnum {
  DIRECTOR = 'Director',
  PRESIDENT = 'President',
  VICE_PRESIDENT = 'VicePresident',
  SECRETARY = 'Secretary',
  TREASURER = 'Treasurer',
}

export const KEY_PERSON_ROLES_ENUM_TO_TEXT = {
  [KeyPersonRolesEnum.DIRECTOR]: 'Director',
  [KeyPersonRolesEnum.PRESIDENT]: 'President',
  [KeyPersonRolesEnum.VICE_PRESIDENT]: 'Vice President',
  [KeyPersonRolesEnum.SECRETARY]: 'Secretary',
  [KeyPersonRolesEnum.TREASURER]: 'Treasurer',
};

export const KEY_PERSON_ROLE_OPTIONS = Object.values(KeyPersonRolesEnum).map(
  (role) => ({ value: role, label: KEY_PERSON_ROLES_ENUM_TO_TEXT[role] })
);

export const getKeyPersonRoles = (
  person: IPersonOfBusinessEntity
): KeyPersonRolesEnum[] => {
  const roles: KeyPersonRolesEnum[] = [];

  const relationship = person?.governanceRelationships;

  const directorGovernanceRelationship =
    relationship?.[GovernanceRole.DIRECTOR];
  const authorizedSignatoryGovernanceRelationship =
    relationship?.[GovernanceRole.AUTHORIZED_SIGNATORY];

  if (
    !directorGovernanceRelationship &&
    !authorizedSignatoryGovernanceRelationship
  )
    return [];

  if (directorGovernanceRelationship?.isDirector)
    roles.push(KeyPersonRolesEnum.DIRECTOR);
  if (directorGovernanceRelationship?.boardPositions?.length > 0) {
    directorGovernanceRelationship.boardPositions.forEach((position) =>
      roles.push(position as unknown as KeyPersonRolesEnum)
    );
  }

  return roles;
};
